import { render } from "./Product.vue?vue&type=template&id=6e4166cb"
import script from "./Product.vue?vue&type=script&lang=js"
export * from "./Product.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Code Backup\\ts-web-old\\TatSingGroup-Web\\ts-trading\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__